import Ajax from '@utils/ajax';

export default {
  fetch(options = {}) {
    return Ajax.get({
      url: `/app_invites`,
      ...options,
    });
  },

  createPendingUser(data, options = {}) {
    return Ajax.post({
      url: `/app_invites/create_pending_user`,
      data: data,
      ...options,
    });
  },

  skipInviteCode(userId, options = {}) {
    return Ajax.post({
      url: `/app_invites/skip_invite_code`,
      data: { user_id: userId },
      ...options,
    });
  },

  updatePendingUser(code, data, options = {}) {
    return Ajax.post({
      url: `/app_invites/${code}/update_pending_user`,
      data: data,
      ...options,
    });
  },

  convertPendingUserToUser(code, data, options = {}) {
    return Ajax.post({
      url: `/app_invites/${code}/convert_pending_user_to_user`,
      data: data,
      ...options,
    });
  },

  get(code, options = {}) {
    return Ajax.get({
      url: `/app_invites/${code}`,
      ...options,
    });
  },

  update(code, data, options = {}) {
    return Ajax.post({
      url: `/app_invites/${code}`,
      data: { app_invite: data, _method: 'PATCH' },
      ...options,
    });
  },
};
